import script from "./DoctorForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorForm.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorForm.vue?vue&type=style&index=0&id=3dfe8856&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfe8856"]])

export default __exports__